<template>
  <v-btn
    class="text-body-m-bold"
    depressed
    v-bind="$attrs"
    v-on="$listeners"
    :class="{ 'thin-borders' : thinBorders }"
  >
    <slot />
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseButton',
  props: {
    thinBorders: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped lang="scss">
.v-btn {
  &::before {
    background-color: transparent;
  }

  text-transform: none;
  border-radius: 8px;

}
.v-btn--outlined {
  border: 2px solid currentColor;
  background-color: transparent;

  &.thin-borders {
    border: 1px solid currentColor !important;
  }
}
</style>

<style lang="scss">
.v-btn {
  &.v-btn--outlined.v-btn--disabled {
    .v-btn__content span {
      color: var(--v-neutral-tone-400) !important;
    }
  }
}
</style>
